import { render, staticRenderFns } from "./FooterNew.vue?vue&type=template&id=d7cfc780&scoped=true&"
import script from "./FooterNew.vue?vue&type=script&lang=js&"
export * from "./FooterNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cfc780",
  null
  
)

export default component.exports